export default __webpack_public_path__ + "static/media/tumorChannel2.15e954af.png";